import React from 'react';
import { Gamic } from '../pages/Publisher/Gamics/types';

export type Status =
  | 'Approved'
  | 'Rejected'
  | 'Pending'
  | 'On Going'
  | 'Resolved'
  | 'Hold'
  | 'Running'
  | 'Completed'
  | 'Active'
  | 'Paused';
  

const classes: Record<Gamic['status'], string> = {
  Approved: 'bg-[#00A110] text-white',
  Rejected: 'bg-[#FF0000] text-white',
  Pending: 'bg-[#FBBC05] text-white',
  Running: 'bg-[#14D8CE] text-white',
  'On Going': 'bg-[#14D8CE] text-white',
  Resolved: 'bg-[#016D06] text-white',
  Hold: 'bg-[#14D8CE] text-white',
  Completed : 'bg-[#00A110] text-white',
  Active: 'bg-[#14D8CE] text-white',
  Paused: 'bg-[#FBBC05] text-white',
};

interface Props {
  status: Gamic['status'];
}

export const LabelTag = (props2: any) => <>{props2.children}</>;

const specialMap: Record<string, Status> = {
  in_progress: 'On Going',
  // yahan aur special cases add kar sakte ho agar chaaho
};

const formatStatus = (raw: string): Status => {
    if (raw in specialMap) {
    return specialMap[raw];
  }
  
  const formatted = raw
    .replace(/_/g, ' ')
    .split(' ')
    .map(
      w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
    )
    .join(' ') as Status;

  // Fallback in case API gives an unexpected value
  return (formatted in classes) ? formatted : (raw as Status);
};


const StatusBadge: React.FC<Props> = ({ status }) => {
  const displayStatus = formatStatus(status);

  return (
    <span
      className={`w-[100px] h-[32px] flex items-center justify-center rounded-[8px] ${
        classes[displayStatus]
      }`}
    >
      {displayStatus}
    </span>
  );
};

export default StatusBadge;
